import {MetricForecast, WorkstreamMetric} from 'client';

const getForecastYear = (period: string) => {
  const match = /^(\d{4})/.exec(period.trim());
  return match ? Number(match[1]) : null;
};

const hasForecastValue = (forecast: MetricForecast) =>
  [forecast.actual, forecast.target, forecast.budget].some(
    (value) => value != null && value.trim() !== ''
  );

/** Years (ascending) that have at least one populated forecast value across the metrics. */
export const getMetricValueYears = (metrics: WorkstreamMetric[]): number[] => {
  const years = new Set<number>();

  for (const metric of metrics) {
    for (const forecast of metric.metric_forecasts ?? []) {
      const year = getForecastYear(forecast.period);
      if (year != null && hasForecastValue(forecast)) {
        years.add(year);
      }
    }
  }

  return [...years].sort((a, b) => a - b);
};
